import { privateRequest, referralRequest, type ApiResponse } from "../axios";

export interface UserData {
  CityId: number;
  CountryId: number,
  From: number,
  IsActive: boolean,
  ManagerId: string,
  RoleIds: string,
  SearchText: string,
  StateId: number;
  LocalityId: string;
  To: number,
  departmentIds: string,
  designationIds: string,
  branchIds: string,
  UserId?: number
};

const ENDPOINTS = {
  USER_WORKSTATION: "api/WorkStation",
  USER_DATA: 'api/Users',
  ASSIGN_TEAM: 'api/CRM/AssignTeam',
  DEPARTMENT_LIST: 'api/Departments',
  DESIGNATION_LIST: 'api/Designations',
  BRANCH_LIST: 'api/Branch',
  ROLES: 'api/Roles',
  USER_DETAILS: 'api/v1/Users',
  NOT_TEAM_MEMBER: "api/CRM/NotTeamMembers",
  DEACTIVATE: "api/Users/${Id}/Deactivate",
  ASSIGN_MANAGER: "api/CRM/UpdateManager",
  BASIC_INFO: "api/V1/UserBasicInfo",
  CURRENT_POSITION: "api/V1/CurrentPositionDetails",
  STATUTORY_INFO: "api/V1/EmployeeStatutoryDetails",
  BANK_DETAILS: "api/V1/EmployeeBankDetails",
  MY_TEAM: "api/CRM/MyTeam",
  BACKGROUND_CHECK: "api/V1/BackgroundCheck",
  JOINING_INFO: "api/V1/JoiningDetails",
  PERSONAL_INFO: "api/V1/PersonalDetails",
  PRESENT_ADDRESS: "api/V1/EmployeeAddressDetails",
  COUNTRY_LIST : 'api/GetCountryList',
  STATE_LIST : "api/GetStateList",
  CITY_LIST  : "api/GetCityList",
  LOCALITY_LIST : "api/GetLocalityList",
  EMERGENCY_CONTACT_DETAILS: "api/EmergencyContactDetails",
  DELETE_EMERGANCY_CONTACT: "api/DeleteEmergencyContactDetails",
  EDUCATION_DETAILS: "api/V1/EmployeeEducationDetails",
  DELETE_EDUCATION_DETAILS: "api/DeleteEduCationDetails",
  EMPLOYEE_IDENTITY: "api/V1/EmployeeIdentityDetails",
  DELETE_EMPLOYEE_IDENTITY: "api/DeleteDocuments",
  DOCUMENT_LIST: "api/V1/GetDocumentList",
  UPLOAD_IMAGE: "api/V1/UpdateProfileImage",
  DELETE_UPLOAD_IMAGE: "api/V1/DeleteProfileImage",
  IFSC_CODE: "https://ffcreferral.fieldforceconnect.com/referral/ReferralUser/GetIFSCDetails?code",
  MANAGER: "api/Users/GetManagers",
  QUALIFICATION: 'api/Users/Education',
  USER_EXPORT: "api/Users/Export",
  UPDATE_USERS_BULK_UPLOAD: "api/CRM/BulkUploadUserWithManager",
  USERS_BULK_UPLOAD_FILES: "api/Users/BulkUpload/FileName",
  USERS_BULK_UPLOAD_EXPORT_REPORT: "api/Users/BulkUpload/ExportUsersReport",
  USERS_BULK_UPLOAD_EXPORT_FILE: "api/Users/BulkUpload/ExportUsersFile",
  USERS_BULK_UPLOAD_VIEW_REPORT: "api/Users/BulkUpload/UsersViewReport",
  UPDATE_WORKING_LOCATION: "api/UpdateUserWorkingDetails",
  GET_WORKING_LOCATION: "api/GetUserWorkingDetails",
  AUDIT_LOG: "api/UserAuditLog",
  AUDIT_LOG_DETAILS: "api/UserAuditLogs",
};

const getWorkStations = async (): Promise<any> => {
  const response = await privateRequest.get(`${ENDPOINTS.USER_WORKSTATION}?From=1&To=-1&Search=&IsActive=true`);
  return response;
};

const getUsersData = async (data: UserData): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.USER_DATA}`, { params: data });
  return res.data;
}

export const getAuditLog = async (data: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.AUDIT_LOG}`, { params: data });
  return res.data;
};

export const getAuditLogDetails = async (data: {
  userId: number;
  createdBy?: string | number;
  fromDate?: string;
  toDate?: string;
  search?: string;
}): Promise<any> => {
  const params = {
    "userLogDetails.createdBy": data.createdBy ?? "",
    "userLogDetails.fromDate": data.fromDate ?? "",
    "userLogDetails.toDate": data.toDate ?? "",
    "userLogDetails.search": data.search ?? "",
  };
  const res = await privateRequest.get(`${ENDPOINTS.AUDIT_LOG_DETAILS}/${data.userId}/Details`, { params });
  return res.data;
};

const getAssignTeam = async (payload: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_TEAM}`, payload)
  return res.data;
}

const getDocumentList = async (): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.DOCUMENT_LIST}`)
  return res.data;
}

export const getCountryList = async() : Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.COUNTRY_LIST}`)
  return res.data;
}

const getManagerList = async (data: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.USER_DATA}`, { params: data });
  return res.data;
}

const getDepartmentList = async (data: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.DEPARTMENT_LIST}`, { params: data });
  return res.data;
}

const getDesignationList = async (data: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.DESIGNATION_LIST}`, { params: data });
  return res.data;
}

const getBranchList = async (data: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.BRANCH_LIST}`, { params: data });
  return res.data;
}

const getRolesList = async (): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.ROLES}`);
  return res.data;
}

const addUserdetails = async (data: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.USER_DETAILS}`, data);
  return res
}

const getNotTeamMemberList = async (payload: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.NOT_TEAM_MEMBER}`, payload);
  return res
}

const AssignTeam = async (payload: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_TEAM}`, payload);
  return res.data;
}

const deactivate = async (Id: any): Promise<any> => {
  return await privateRequest.put(`api/Users/${Id}/Deactivate`, Id)
}

const activate = async (Id: any): Promise<any> => {
  return await privateRequest.put(`api/Users/${Id}/activate`, Id)
}

const removemanger = async (userId: any, managerId: any): Promise<any> => {
  return await privateRequest.put(`api/Users/${userId}/DeleteManager/${managerId}`)
}

const assignManager = async (payload: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.ASSIGN_MANAGER}`, payload)
  return res.data
}

const viewUser = async (userId: any): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.USER_DATA}/${userId}`)
  return res.data;
}

const putUser = async (userId: number, payload: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.USER_DATA}/${userId}`, payload);
  return res.data;
};

const basicInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.BASIC_INFO}/${userId}`, payload)
  return res.data;
}

const currentPosition = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.CURRENT_POSITION}/${userId}`, payload)
  return res.data;
}

const statutoryInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.STATUTORY_INFO}/${userId}`, payload)
  return res.data;
}

const bankInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.BANK_DETAILS}/${userId}`, payload)
  return res.data;
}

const backgroundCheckInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.BACKGROUND_CHECK}/${userId}`, payload)
  return res.data;
}

const joiningInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.JOINING_INFO}/${userId}`, payload)
  return res.data;
}

const personalInfo = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.PERSONAL_INFO}/${userId}`, payload)
  return res.data;
}

const presentAddress = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.PRESENT_ADDRESS}/${userId}`, payload)
  return res.data;
}

const emergencyContact = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.EMERGENCY_CONTACT_DETAILS}/${userId}`, payload)
  return res.data;
}

const deleteEmergencyContact = async (contactId: any): Promise<any> => {
  const res = await privateRequest.delete(`${ENDPOINTS.DELETE_EMERGANCY_CONTACT}/${contactId}`)
  return res.data;
}

const educationDetails = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.EDUCATION_DETAILS}/${userId}`, payload)
  return res.data;
}

const deleteEducationDetails = async (payload: any): Promise<any> => {
  const res = await privateRequest.delete(`${ENDPOINTS.DELETE_EDUCATION_DETAILS}`, { data: payload });
  return res.data;
}

const employeeIdentity = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.EMPLOYEE_IDENTITY}/${userId}`, payload)
  return res.data;
}

const deleteEmployeeIdentity = async (payload: any): Promise<any> => {
  const res = await privateRequest.delete(`${ENDPOINTS.DELETE_EMPLOYEE_IDENTITY}`, { data: payload });
  return res.data;
}

const getMyTeamList = async (data: any): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.MY_TEAM}`, data);
  return res.data;
}

const getIfscCode = async (code: any): Promise<any> => {
  const res = await referralRequest.get(`/referral/ReferralUser/GetIFSCDetails?code=` + code);
  return res.data;
}

export const getStateList = async(countryId : number) : Promise<any> =>{
  const res = await privateRequest.get(`${ENDPOINTS.STATE_LIST}?CountryId=` +countryId)
  return res.data;
}

export const getCityList = async(stateId : number) : Promise<any> =>{
  const res = await privateRequest.get(`${ENDPOINTS.CITY_LIST}?StateId=` +stateId)
  return res.data;
}

export const getLocalityList = async(cityId : number) : Promise<any> =>{
  const res = await privateRequest.get(`${ENDPOINTS.LOCALITY_LIST}?CityId=` +cityId)
  return res.data;
}

const uploadImage = async (payload: any, userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.UPLOAD_IMAGE}/${userId}`, payload)
  return res.data;
}

const deleteUploadImage = async (userId: any): Promise<any> => {
  const res = await privateRequest.put(`${ENDPOINTS.DELETE_UPLOAD_IMAGE}/` + userId);
  return res.data;
}

const getManagers = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.MANAGER);
  return res.data;
}

const getQualificationList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.QUALIFICATION, { params: data });
  return res.data;
}

const getUserExport = async (data: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_EXPORT, { params: data, responseType: "arraybuffer" });
  return res;
}

const updateUsersBulkUpload = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.UPDATE_USERS_BULK_UPLOAD, data);
  return res.data;
};

const getUsersBulkUploadFiles = async (data: any): Promise<any> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USERS_BULK_UPLOAD_FILES, { params: data });
  return res;
};

const exportUsersBulkUploadReport = async (fileId: number) => {
  const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.USERS_BULK_UPLOAD_EXPORT_REPORT}/${fileId}`, {}, { responseType: "arraybuffer" });
  return res;
};

const exportUsersBulkUploadFile = async (fileId: number) => {
  const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.USERS_BULK_UPLOAD_EXPORT_FILE}/${fileId}`, {}, { responseType: "arraybuffer" });
  return res;
};

const getUsersBulkUploadViewReport = async (data: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USERS_BULK_UPLOAD_VIEW_REPORT, { params: data });
  return res;
};

const getUserById = async (Id: number): Promise<any> => {
  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.USER_DATA}/${Id}`);
  return res.data
}

const getUserPermissions = async (userId: number): Promise<any> => {
  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.USER_DATA}/${userId}/Permissions`);
  return res.data;
};

const deleteInactiveUser = async (userId: number): Promise<any> => {
  const res = await privateRequest.delete(`${ENDPOINTS.USER_DATA}/${userId}`);
  return res.data;
}

const updateWorkingLocation = async (payload: any, userId: number): Promise<any> => {
  const res = await privateRequest.post(`${ENDPOINTS.UPDATE_WORKING_LOCATION}?updateUserId=${userId}`, payload);
  return res.data;
};

const getWorkingLocation = async (userId: number): Promise<any> => {
  const res = await privateRequest.get(`${ENDPOINTS.GET_WORKING_LOCATION}/${userId}`);
  return res.data;
};

const UserService = {
  getWorkStations,
  getUsersData,
  getAssignTeam,
  getCountryList,
  getManagerList,
  getDepartmentList,
  getDesignationList,
  getBranchList,
  getRolesList,
  addUserdetails,
  getNotTeamMemberList,
  deactivate,
  activate,
  removemanger,
  AssignTeam,
  assignManager,
  viewUser,
  putUser,
  basicInfo,
  currentPosition,
  statutoryInfo,
  bankInfo,
  getMyTeamList,
  getIfscCode,
  backgroundCheckInfo,
  joiningInfo,
  personalInfo,
  presentAddress,
  getStateList,
  getCityList,
  getLocalityList,
  emergencyContact,
  deleteEmergencyContact,
  educationDetails,
  deleteEducationDetails,
  employeeIdentity,
  deleteEmployeeIdentity,
  getDocumentList,
  uploadImage,
  deleteUploadImage,
  getManagers,
  getQualificationList,
  getUserExport,
  updateUsersBulkUpload,
  getUsersBulkUploadFiles,
  exportUsersBulkUploadReport,
  exportUsersBulkUploadFile,
  getUsersBulkUploadViewReport,
  getUserById,
  getUserPermissions,
  deleteInactiveUser,
  getWorkingLocation,
  updateWorkingLocation,
  getAuditLog,
  getAuditLogDetails,
};

export default UserService;
